import OptionsStore from './schema/OptionsStore';
import { createStore } from 'satcheljs';
import '../mutators/index';
import '../orchestrators/index';
import 'mini-options-message-options';

const optionsStoreData: OptionsStore = {
    activeViewState: null,
};

export let getOptionsStore = createStore<OptionsStore>('options', optionsStoreData);

const optionsStore = getOptionsStore();

export default optionsStore;
